import Request from './request';
import consts from "@/consts.js";
import store from '../store'
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';

async function fetch(data) {
    return Request('get', "api/food-formula/", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/food-formula/select", data, false, false, true);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/food-formula/" + id);
}

async function getSettingInfo(id) {// 获取配方设定详情
    return Request('get', "api/formula-cost-card/get-cost-card?formula_id=" + id);
}

async function save(id,data){// 编辑或新建数据（有id为编辑，没有id为新建）
    if(id){
        return Request('post', "api/food-formula/edit?id=" + id, data);
    } else {
        return Request('post', "api/food-formula/add" , data);
    }
}

async function del(id){// 删除数据
    return Request('get', "api/food-formula/delete/", id ? { id: id} : {});
}

async function saveSettingInfo(data){// 保存
    return Request('post', "api/formula-cost-card/batch-save", data);
}

async function imports(file) {// 菜品bom导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/foods/import-bom", data);
}

async function batchEditImports(file) {// 批量菜品bom修改导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/food-formula/import-batch-edit-bom", data);
}
  
async function editTemplateExport(data) {// 批量菜品bom修改导入模板
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/food-formula/edit-template-export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function batchDeleteForMaterials(id){// 批量删除数据
    return Request('delete', "api/food-formula/batch-delete-for-materials/"+ id);
}

export default {
    fetch,
    fetchAllForSelect,
    fetchOne,
    getSettingInfo,
    save,
    del,
    saveSettingInfo,
    imports,
    batchDeleteForMaterials,
    batchEditImports,
    editTemplateExport,
};